import React from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { isFeatureEnabled } from "@editor/infra/featureFlags";
import { trpc } from "@editor/utils/trpc";

import { useParams } from "react-router-dom";

import EditorChat from "../react-editor/components/EditorChat";
import ManageChats from "../react-editor/components/ManageChats";
import ManageFunnels from "../react-editor/components/ManageFunnels";
import FunnelEditor from "./components/FunnelEditor";

function Funnel() {
  const isReaplo = isFeatureEnabled("reaplo");
  const projectId = useCurrentProjectId();
  const { funnelId } = useParams();

  const { data: funnel } = trpc.funnel.find.useQuery(
    {
      projectId: projectId ?? "",
      funnelId: funnelId ?? "",
    },
    {
      enabled: Boolean(isReaplo && projectId && funnelId),
    },
  );

  if (!isReaplo) {
    window.location.href = `/projects/${projectId}`;
    return null;
  }

  if (!funnelId) {
    return null;
  }

  return (
    <div className="flex h-screen gap-3 p-3">
      <div className="flex h-full flex-col gap-5">
        <div className="flex h-full min-h-0 max-h-[100px] max-w-md flex-col gap-4 rounded-md border p-4">
          <h1 className="text-2xl font-bold">Current Funnel: {funnel?.name}</h1>
          <ManageFunnels />
        </div>

        <div className="flex h-full min-h-0 max-w-md flex-col gap-4 rounded-md border p-4">
          <h1 className="text-2xl font-bold">Funnel Chat</h1>
          <ManageChats />
          <EditorChat />
        </div>
      </div>

      <FunnelEditor funnelId={funnelId} />
    </div>
  );
}

export default Funnel;
